<script>

import {mapActions} from 'vuex';

import LoginTemplate from './LoginTemplate';
import utilsService from "../../../services/UtilsService";
import Password from 'vue-password-strength-meter';

export default {
    components: {
        LoginTemplate,
        Password
    },
    data() {
        return {
            lang: 'pt',
            token: '',
            username: '',
            password: '',
            repeatPassword: '',
            error: '',
            errors: [],
        }
    },
    mounted() {

        this.token = this.$route.query.token;

        if (!this.token) {
            this.backToLogin();
        }

        if (this.$route.query.lang === "en") {
            this.lang = "en";
        } else if (this.$route.query.lang === "es") {
            this.lang = "es";
        }

        utilsService.localStorageSetItem("USER_LOCALE", this.lang);
        this.$i18n.locale = this.lang;
    },
    computed: {
        isValidToSubmit: function () {
            return this.username && this.password && this.repeatPassword;
        }
    },
    methods: {
        ...mapActions(['changePasswordByToken']),
        backToLogin: function () {

            this.$router.push({path: '/auth'});
        },
        doChangePassword: function () {

            let self = this;

            self.error = "";
            self.errors = [];

            if (self.password !== self.repeatPassword) {

                self.error = this.$t('newPasswordAndRepeatPasswordAreDifferentValues');

            } else {

                self.$loader.show()

                this.changePasswordByToken({
                    username: self.username,
                    password: self.password,
                    token: self.token,
                }).then(response => {

                    let code = response.meta.code;
                    self.$loader.hide();

                    if (code === 200) {

                        this.$notify({
                            title: this.$t("success"),
                            message: this.$t("passwordUpdatedWithSuccess"),
                            type: 'success'
                        });

                        this.backToLogin();

                    } else if (code === 400) {

                        self.errors = utilsService.buildErrorMessage(response.errors);

                        console.log(response.errors);
                        console.log(self.errors);
                    }

                }).catch((err) => {

                    console.log("Error!");
                    console.log(err);

                    self.error = "ERRO";
                    self.$loader.hide();
                })
            }
        }
    }
}
</script>
<template>

    <login-template>

        <div class="login">
            <h2 class="form-header">{{ $t('changePassword') }}</h2>

            <div class="min-height">
                <bootstrap-alert-errors :errors="errors"></bootstrap-alert-errors>
                <div class="alert alert-mini alert-danger" v-if="error">
                    {{ error }}
                </div>
            </div>

            <form autocomplete="off">
                <fieldset>

                    <div class="form-group">
                        <div class="input-group">
                                            <span class="input-group-addon"><i
                                                class="glyphicon glyphicon-user"></i></span>
                            <input type="text"
                                   name="changePasswordUsername"
                                   class="form-control"
                                   :placeholder="$t('username')"
                                   required=""
                                   v-model="username"
                                   id="changePasswordUsername">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                                            <span class="input-group-addon"><i
                                                class="glyphicon glyphicon-lock"></i></span>
                            <input
                                type="password"
                                name="changePasswordPassword"
                                class="form-control"
                                :placeholder="$t('inputNewPassword')"
                                required=""
                                v-model="password"
                                id="changePasswordPassword"
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                                            <span class="input-group-addon"><i
                                                class="glyphicon glyphicon-lock"></i></span>
                            <input
                                type="password"
                                name="changePasswordRepeatPassword"
                                class="form-control"
                                :placeholder="$t('repeatNewPassword')"
                                required=""
                                v-model="repeatPassword"
                                id="changePasswordRepeatPassword"
                            >
                        </div>
                        <div style="margin-left: 25px;">
                            <password v-model="password" :strength-meter-only="true" :secureLength="2"/>
                        </div>
                    </div>

                    <div>

                        <el-button type="primary" native-type="submit"
                                   @click.prevent="doChangePassword()"
                                   :disabled="!isValidToSubmit" class="form-btn">
                            {{ $t("continue") }}
                        </el-button>

                        <el-button type="primary" native-type="button" @click.prevent="backToLogin()"
                                   class="form-btn">
                            {{ $t("cancel") }}
                        </el-button>

                    </div>

                </fieldset>
            </form>

        </div>

    </login-template>
</template>




// WEBPACK FOOTER //
// ChangePassword.vue?71d734ac